module.exports = __webpack_public_path__ + "static/media/jacket.5e63acf5.webp";